import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Styles from './Icon.module.scss';

import ArrowDown from './icons/ArrowDown';
import ArrowDownSmall from './icons/ArrowDownSmall';
import ArrowDownOutline from './icons/ArrowDownOutline';
import ArrowDownSmallOutline from './icons/ArrowDownSmallOutline';
import ArrowRightOutline from './icons/ArrowRightOutline';
import ArrowRight from './icons/ArrowRight';
import ArrowTop from './icons/ArrowTop';
import Attachment from './icons/Attachment';
import BackArrow from './icons/BackArrow';
import Bell from './icons/Bell';
import Calendar from './icons/Calendar';
import Chat from './icons/Chat';
import CloseSmall from './icons/CloseSmall';
import Close from './icons/Close';
import Download from './icons/Download';
import Filter from './icons/Filter';
import Pen from './icons/Pen';
import Remove from './icons/Remove';
import Settings from './icons/Settings';
import Tick from './icons/Tick';
import UserManual from './icons/UserManual';
import Plus from './icons/Plus';
import ExclamationMark from './icons/ExclamationMark';
import Upload from './icons/Upload';
import Location from './icons/Location';
import Delete from './icons/Delete';
import Info from './icons/Info';
import History from './icons/History';
import Truck from './icons/Truck';
import Search from './icons/Search';
import InfoSmall from './icons/InfoSmall';
import Change from './icons/Change';
import TrashBin from './icons/TrashBin';
import Split from './icons/Split';

const Icons = {
  ArrowDown,
  ArrowDownSmall,
  ArrowDownOutline,
  ArrowDownSmallOutline,
  ArrowRightOutline,
  ArrowRight,
  ArrowTop,
  ExclamationMark,
  Attachment,
  BackArrow,
  Bell,
  Calendar,
  Chat,
  CloseSmall,
  Close,
  Download,
  Filter,
  Pen,
  Remove,
  Settings,
  Tick,
  UserManual,
  Plus,
  Upload,
  Location,
  Delete,
  Info,
  History,
  Truck,
  TrashBin,
  Search,
  Split,
  InfoSmall,
  Change
};

function camelize(str) {
  const result = str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
  return result.charAt(0).toUpperCase() + result.slice(1);
}

const Icon = ({ icon, hasNotification = false, ...rest }) => {
  const Component = Icons[camelize(icon)];
  const _className = cx(Styles.icon, {
    [Styles.withIndication]: hasNotification
  });

  if (!Component) {
    throw new Error('No such icon in icons list');
  }

  return (
    <span className={_className} {...rest}>
      <Component />
    </span>
  );
};

Icon.propTypes = {
  icon: PropTypes.string,
  hasNotification: PropTypes.bool
};

export default Icon;
